module.exports = __webpack_public_path__ + "static/media/x.0c9462a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x.svg
// module id = 370
// module chunks = 0